export default __webpack_public_path__ + "static/media/VD4.875fec46.png";